import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, Trophy, BookOpen } from 'lucide-react';
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const purchases = [{
    name: 'Martina B.',
    loc: 'Córdoba',
    pack: 'PackViajero Expert',
    icon: <Trophy className="w-3 h-3" data-id="element-298" />,
    time: '7 minutos'
  }, {
    name: 'Juan P.',
    loc: 'CABA',
    pack: 'PackViajero Completo',
    icon: <BookOpen className="w-3 h-3" data-id="element-299" />,
    time: '12 minutos'
  }, {
    name: 'Lucía M.',
    loc: 'Rosario',
    pack: 'PackViajero Expert',
    icon: <Trophy className="w-3 h-3" data-id="element-300" />,
    time: '25 minutos'
  }, {
    name: 'Diego F.',
    loc: 'Mendoza',
    pack: 'PackViajero Expert',
    icon: <Trophy className="w-3 h-3" data-id="element-301" />,
    time: '42 minutos'
  }];
  useEffect(() => {
    // Initial delay before showing first popup
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    // Cycle logic
    const cycleTimer = setInterval(() => {
      setIsVisible(false); // Hide current
      setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % purchases.length); // Change data
        setIsVisible(true); // Show next
      }, 1000); // Wait 1s before showing next
    }, 12000); // Show for 11s, hide for 1s
    return () => {
      clearTimeout(initialTimer);
      clearInterval(cycleTimer);
    };
  }, [purchases.length]);
  const current = purchases[currentIndex];
  return <AnimatePresence data-id="element-302">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 z-50 max-w-sm w-[calc(100%-2rem)] sm:w-auto" data-id="element-303">
          <div className="bg-slate-800/95 backdrop-blur-md border border-slate-700 shadow-2xl rounded-xl p-4 flex gap-4 items-start" data-id="element-304">
            <div className="bg-green-500/20 p-2 rounded-full shrink-0 mt-1" data-id="element-305">
              <CheckCircle2 className="w-5 h-5 text-green-400" data-id="element-306" />
            </div>
            <div data-id="element-307">
              <div className="flex items-center gap-2 mb-1" data-id="element-308">
                <span className="text-xs font-bold text-slate-400 uppercase tracking-wider" data-id="element-309">
                  Compra verificada
                </span>
                <span className="text-xs text-slate-500" data-id="element-310">
                  hace {current.time}
                </span>
              </div>
              <p className="text-sm text-white leading-snug" data-id="element-311">
                <span className="font-bold" data-id="element-312">{current.name}</span> de{' '}
                {current.loc} compró
              </p>
              <div className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded text-xs font-bold mt-2 ${current.pack.includes('Expert') ? 'bg-amber-500/20 text-amber-400' : 'bg-blue-500/20 text-blue-400'}`} data-id="element-313">
                {current.icon} {current.pack}
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}